import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import {Col, Form, FormGroup, Row, Button, Modal, FormControl} from "react-bootstrap";
import { connect } from 'react-redux';

import {driverDepositMakeReturn, driverDepositInstantInvoiceProduct} from  "../../actions/deposit_driver";
import { stateToCenterId } from "../../../../utils/center";
import "../../css/Deposit.css";

const Internal = ({driver, deposit_driver, centers, currentCenterId, validate, handleSubmit, handleInvoiceProduct}) => {

  // Vérifier si la fonctionnalité est activée pour ce centre
  const currentCenter = centers.find(c => c.id === currentCenterId);
  const isDynamicBillingEnabled = currentCenter && currentCenter.dynamic_consigne_billing_enabled === true;

  // États pour les modals
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [invoiceQuantity, setInvoiceQuantity] = useState(0);
  const [invoiceReason, setInvoiceReason] = useState("");
  const [submittingInvoice, setSubmittingInvoice] = useState(false);
  const [invoicingProductId, setInvoicingProductId] = useState(null);

  let products = deposit_driver.products.filter(p => p.quantity_debt > 0);
  if (products.length === 0) {
    return <div><br /><p className="alert alert-info">{`Le livreur n'a plus de produit consigné en sa possession`}</p></div>;
  }

  const handleInvoiceClick = (prod, formQuantity) => {
    // Utiliser la quantité du formulaire si renseignée, sinon la dette totale
    const quantity = parseFloat(formQuantity) || prod.quantity_debt;
    setSelectedProduct(prod);
    setInvoiceQuantity(quantity);
    setInvoiceReason("");
    setShowInvoiceModal(true);
  };

  const confirmInvoice = async () => {
    if (selectedProduct && invoiceQuantity > 0 && !submittingInvoice) {
      setSubmittingInvoice(true);
      setInvoicingProductId(selectedProduct.id);
      setShowInvoiceModal(false);

      try {
        await handleInvoiceProduct(driver.id, selectedProduct.id, selectedProduct.deposit_label, parseFloat(invoiceQuantity), currentCenterId, invoiceReason);
        // Succès : réinitialiser l'état
        setSubmittingInvoice(false);
        setInvoicingProductId(null);
        setSelectedProduct(null);
        setInvoiceQuantity(0);
        setInvoiceReason("");
      } catch (error) {
        // Erreur : réinitialiser l'état pour permettre de réessayer
        setSubmittingInvoice(false);
        setInvoicingProductId(null);
      }
    }
  };

  return <div className="DepositDriverReturn">
    {products.length > 0 &&
      <div>
        <Row>
          <Col as={Form.Label} sm={6}>
            Produit
          </Col>
          <Col as={Form.Label} sm={2}>
            Qté
          </Col>
          <Col as={Form.Label} sm={4}>
          </Col>
        </Row>
        {products.map(prod => (
          <Formik
            key={prod.id}
            initialValues={{
              quantity : 0,
              product_id: prod.id,
            }}
            onSubmit={async (values, actions) => {
              // Dirty fix étrange mais sans le sleep, on ne passe pas en mode isSubmitting
              // Peut-être lié à https://github.com/jaredpalmer/formik/issues/1957
              actions.setSubmitting(true);
              const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
              await sleep(1);
              if (validate(values)) {
                if (values.quantity < 0) {
                  if (!window.confirm('La quantité est négative. Le client ne sera pas remboursé. Êtes vous sûr ?')) {
                    return;
                  }
                }
                handleSubmit(driver.id, values);
                actions.resetForm();
              }
              actions.setSubmitting(false);
            }}
          >
            {props => (
              <div>
                <Form onSubmit={props.handleSubmit}>
                  <FormGroup as={Row} controlId="formControlsSelect">
                    <Col sm={6} className="deposit-flex">
                      <div className="deposit-center">
                        <Field name="product_id" type="hidden" className="form-control" component="input" />
                        <img src={prod.picture_thumbnail_url} alt={prod.deposit_label} width="50" />
                        {prod.deposit_label} (à rendre x {prod.quantity_debt})
                      </div>
                    </Col>
                    <Col sm={2} className="deposit-flex deposit-qty">
                      <div className="deposit-center">
                        <Field name="quantity" type="number" required="required"
                          className="form-control" component="input" max={prod.quantity_debt} min="0" />
                        <span>max: {prod.quantity_debt}</span>
                      </div>
                    </Col>
                    <Col sm={4} className="deposit-flex">
                      <div className="deposit-center" style={{ gap: '5px', display: 'flex' }}>
                        <button type="submit" className="btn btn-primary" disabled={props.isSubmitting}>OK</button>
                        {isDynamicBillingEnabled && (
                          <>
                            <button
                              type="button"
                              className="btn btn-warning"
                              onClick={() => handleInvoiceClick(prod, props.values.quantity)}
                              disabled={invoicingProductId === prod.id}
                            >
                              {invoicingProductId === prod.id ? 'Facturation...' : 'Facturer'}
                            </button>
                          </>
                        )}
                      </div>
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            )}
          </Formik>
        ))}
      </div>
    }

    {/* Note: unlock UI removed — unblocking is handled at the driver level now */}

    {/* Modal facturation */}
    <Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)}>
      <Modal.Body>
        <button type="button" className="close" onClick={() => setShowInvoiceModal(false)}>&times;</button>
        <FormGroup>
          <label className="control-label">Raison de la facturation (facultatif)</label>
          <FormControl
            componentClass="textarea"
            rows={3}
            placeholder="Ex: Produit perdu, endommagé, non retourné après relances..."
            value={invoiceReason}
            onChange={(e) => setInvoiceReason(e.target.value)}
          />
          <p className="help-block text-muted">
            La facturation sera ajoutée sur la prochaine facture mensuelle du livreur. Cette action est définitive et entraînera la suppression de la dette.
          </p>
        </FormGroup>
        <Modal.Footer>
          <Button onClick={() => setShowInvoiceModal(false)} variant="outline-secondary" disabled={submittingInvoice}>Annuler</Button>
          <Button variant="primary" onClick={confirmInvoice} disabled={submittingInvoice}>
            {submittingInvoice ? 'Facturation en cours...' : 'Confirmer la facturation'}
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  </div>;
};

Internal.propTypes = {
  driver: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool,
  deposit_driver: PropTypes.object.isRequired,
  centers: PropTypes.array.isRequired,
  currentCenterId: PropTypes.number.isRequired,
  validate: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleInvoiceProduct: PropTypes.func.isRequired,
};

export const DepositDriverReturn = connect(
  (state) => {
    return {
      deposit_driver: state.dispatch.deposit.driver,
      centers: state.dispatch.metas.centers || [],
      currentCenterId: stateToCenterId(state),
      "validate": (values) => {
        if (values.product_id && values.quantity && values.quantity > 0) {
          return true;
        }
        return false;
      },
    };
  },
  (dispatch) => {
    return {
      "handleSubmit": (driver_id, values) => {
        dispatch(driverDepositMakeReturn(driver_id, values.product_id, values.quantity));
      },
      "handleInvoiceProduct": (driver_id, product_id, deposit_label, quantity, center_id, reason) => {
        return dispatch(driverDepositInstantInvoiceProduct(driver_id, product_id, deposit_label, quantity, center_id, reason));
      },
    };
  }
)(Internal);
